module.exports = __webpack_public_path__ + "static/media/23.34aae800.jpg";